export default {
	items: [],
	timeline: "one_year",
	is_daily_history:true,
}